import { struct } from 'io-ts/Decoder';

import { Details as Subscription } from '../../../../push/subscription/Details';

export const Request = struct({
	subscription: Subscription,
});
